import { defineModule } from '@/app/router/defineModule.ts';
import shouldBeAuthenticated from '@/app/router/middleware/shouldBeAuthenticated.js';
import enforceTwoFactor from '@/app/router/middleware/enforceTwoFactor.js';
import ensureUserIsVerified from '@/app/router/middleware/ensureUserIsVerified.js';
import InvoiceLayout from '#modules/invoices/layouts/InvoiceLayout.vue';
import CFInvoicesSidebar from '#modules/invoices/components/CFInvoicesSidebar.vue';
import { AppPermissions } from '#modules/auth/constants/permissions.js';

export default defineModule({
    name: 'invoices',
    routes: [
        {
            path: '/invoices',
            component: InvoiceLayout,
            meta: {
                layout: 'app-sidebar',
                sidebar: CFInvoicesSidebar,
                permissions: [AppPermissions.ManageFinancial],
                middleware: [shouldBeAuthenticated, enforceTwoFactor, ensureUserIsVerified],
            },
            children: [
                {
                    path: '',
                    name: 'invoices',
                    component: () => import('#modules/invoices/pages/index.vue'),
                },
                {
                    path: ':invoice',
                    name: 'single invoice',
                    component: () => import('#modules/invoices/pages/show.vue'),
                },
            ],
        },
    ],
});
